import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mail } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { content, CONTACT_EMAIL } from "@/content/fitswag";

export default function Footer() {
  const { lang } = useLanguage();
  const t = content[lang].footer;
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => {
    if (location.pathname !== "/") navigate("/#" + id);
    else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="border-t border-white/10 bg-black py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <p className="overline text-brand-orange">{t.contactTitle}</p>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="footer-email"
          className="mt-4 flex items-center gap-4 font-display text-4xl leading-none tracking-tighter text-white transition-colors hover:text-brand-orange sm:text-5xl md:text-6xl"
        >
          <Mail className="hidden shrink-0 sm:block" size={40} />
          {CONTACT_EMAIL}
        </a>

        <div className="mt-16 flex flex-col gap-8 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-brand-orange">
              <span className="font-display text-base leading-none text-black">F</span>
            </span>
            <span className="font-display text-lg tracking-tight text-white">
              Fit<span className="text-brand-orange">Swag</span>
            </span>
            <span className="ml-3 hidden text-sm text-white/40 sm:inline">— {t.tagline}</span>
          </div>

          <nav className="flex flex-wrap gap-x-6 gap-y-2 text-sm font-semibold text-white/60">
            <button onClick={() => goSection("features")} className="transition-colors hover:text-white" data-testid="footer-features">
              {t.links.features}
            </button>
            <button onClick={() => goSection("piano")} className="transition-colors hover:text-white" data-testid="footer-how">
              {t.links.how}
            </button>
            <button onClick={() => goSection("faq")} className="transition-colors hover:text-white" data-testid="footer-faq">
              {t.links.faq}
            </button>
            <Link to="/support" className="transition-colors hover:text-white" data-testid="footer-support">
              {t.links.support}
            </Link>
            <Link to="/privacy" className="transition-colors hover:text-white" data-testid="footer-privacy">
              {t.links.privacy}
            </Link>
            <Link to="/terms" className="transition-colors hover:text-white" data-testid="footer-terms">
              {t.links.terms}
            </Link>
          </nav>
        </div>

        <div className="mt-8 flex flex-col gap-1 text-sm text-white/40 md:flex-row md:justify-between">
          <span>{t.rights}</span>
          <span>{t.madeIn}</span>
        </div>
      </div>
    </footer>
  );
}
